export const StorageConstants = {
    LOGIN_TIME: '@artist-login-time',
    LOGIN_TOKEN: '@artist-login-token',
    SIGNUP_TOKEN: '@artist-signup-token',
    USED_ID: '@artist-user-id',
    USER_NAME: '@artist-user-name',
    MOBILE_NUMBER: '@artist-mobile-number',
}